import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';
import logoPdf from '../../assets/logoPdf.jpg';

import imagesBase64 from '../../assets/images';

const coresPerfil = {
  TERRA: '#64C3C0',
  FOGO: '#D62828',
  AGUA: '#6F57A0',
  ÁGUA: '#6F57A0',
  AR: '#00AFA9',
  A: '#00AFA9',
  C: '#EA1D75',
  O: '#00AFA9',
  I: '#EA1D75',
};

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: 'Helvetica',
    fontSize: 12,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    width: 120,
    height: 40,
  },
  logoEmpresa: {
    width: 110,
    height: 35,
  },
  tituloPrincipal: {
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: 10,
    marginBottom: 10,
  },
  cardsResumoWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 10,
  },
  cardResumo: {
    flex: 1,
    border: '1px solid #ccc',
    borderRadius: 8,
    padding: 10,
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: '#f8f8f8',
    height: 100,
    justifyContent: 'space-between',
  },
  cardIconImg: {
    width: 28,
    height: 28,
    marginBottom: 4,
  },
  cardTitulo: {
    fontSize: 11,
    fontWeight: 'bold',
    marginBottom: 2,
  },
  cardValor: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#D32F2F',
  },
  content: {
    marginTop: 15,
  },
  textoSimples: {
    fontSize: 12,
    marginBottom: 6,
  },
  bold: {
    fontWeight: 'bold',
  },
  graficoContainer: {
    width: '100%',
    height: 260,
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #ccc',
    borderRadius: 8,
    padding: 8,
    marginTop: 6,
    marginBottom: 10,
  },
  graficoImagem: {
    width: '100%',
    height: '100%',
  },
  listaParticipantesTitulo: {
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 10,
    marginBottom: 4,
  },
  listaParticipantes: {
    marginTop: 4,
    border: '1px solid #ccc',
    borderRadius: 8,
    padding: 10,
  },
  participanteItem: {
    marginBottom: 4,
    fontSize: 11,
  },
});

const getCor = (perfil) => {
  const key = perfil?.toUpperCase();
  return coresPerfil[key] || '#333';
};

export default function PDFResumoTurma({
  empresa,
  turma,
  total,
  comResultado,
  graficoBarraBase64,
  graficoRadarBase64,
  listaParticipantes,
  listaParticipantesConcluidos,
  listaParticipantesPendentes,
  empresaLogoBase64,
  iconesBase64 = {},
  assignmentMode = 'percent',     // NOVO: modo de atribuição (percent ou raw)
  hasProfileGroups: hasProfileGroupsProp, // NOVO: vem da página
}) {
  const participantesConcluidos = Array.isArray(listaParticipantesConcluidos)
    ? listaParticipantesConcluidos
    : (Array.isArray(listaParticipantes) ? listaParticipantes : []);
  const participantesPendentes = Array.isArray(listaParticipantesPendentes)
    ? listaParticipantesPendentes
    : [];

  const isRawMode = assignmentMode === 'raw';

  // Descobre um perfil qualquer (se existir), só para detectar tipo de teste
  const primeiroComPerfil = participantesConcluidos.find((p) => p.perfil);
  const tipoPerfis = primeiroComPerfil?.perfil?.toUpperCase() || '';
  const isQuatroElementos = ['TERRA', 'FOGO', 'AGUA', 'ÁGUA', 'AR'].includes(tipoPerfis);

  const pendentes = (total || 0) - (comResultado || 0);

  // Detecção automática de agrupamentos pela estrutura dos participantes
  const autoHasGroups =
    participantesConcluidos.length > 0 &&
    participantesConcluidos.some((p) => Array.isArray(p.grupos) && p.grupos.length > 0);

  // Prioriza o valor vindo da página; se não vier, usa auto-detecção
  const hasProfileGroups =
    typeof hasProfileGroupsProp === 'boolean' ? hasProfileGroupsProp : autoHasGroups;

  // Título do gráfico radar conforme modo e se está usando agrupamentos
  const radarTitulo = hasProfileGroups
    ? (isRawMode
        ? 'Média das pontuações por agrupamento:'
        : 'Média dos percentuais por agrupamento:')
    : (isRawMode
        ? 'Média das pontuações:'
        : 'Média dos percentuais:');

  // Título do gráfico de barras conforme agrupamento/perfil
  const barrasTitulo = hasProfileGroups
    ? 'Distribuição por agrupamento predominante:'
    : 'Distribuição por perfil predominante:';

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header com logos */}
        <View style={styles.header}>
          <Image src={logoPdf} style={styles.logo} />
          {empresaLogoBase64 ? <Image src={empresaLogoBase64} style={styles.logoEmpresa} /> : null}
        </View>

        {/* Título */}
        <Text style={styles.tituloPrincipal}>
          {(empresa?.nome || 'Empresa') + ' - ' + (turma?.nome || 'Turma')}
        </Text>

        {/* Cards de resumo com ícones em base64 */}
        <View style={styles.cardsResumoWrapper}>
          <View style={styles.cardResumo}>
            <Image src={imagesBase64.iconFaUsers} style={styles.cardIconImg} />
            <Text style={styles.cardTitulo}>Usuários Inscritos</Text>
            <Text style={styles.cardValor}>{total || 0}</Text>
          </View>
          <View style={styles.cardResumo}>
            <Image src={imagesBase64.iconFaUserCheck} style={styles.cardIconImg} />
            <Text style={styles.cardTitulo}>Usuários que Concluíram</Text>
            <Text style={styles.cardValor}>{comResultado || 0}</Text>
          </View>
          <View style={styles.cardResumo}>
            <Image src={imagesBase64.iconFaUserMinus} style={styles.cardIconImg} />
            <Text style={styles.cardTitulo}>Usuários Pendentes</Text>
            <Text style={styles.cardValor}>{pendentes < 0 ? 0 : pendentes}</Text>
          </View>
        </View>

        {/* Conteúdo detalhado */}
        <View style={styles.content}>
          {/* Tipo de teste */}
          <Text style={styles.textoSimples}>
            <Text style={styles.bold}>Tipo de teste: </Text>
            {isQuatroElementos ? 'Quatro Elementos' : 'Mapa Cerebral'}
          </Text>

          {/* Gráfico de barras (se existir) */}
          {graficoBarraBase64 ? (
            <View>
              <Text style={styles.bold}>{barrasTitulo}</Text>
              <View style={styles.graficoContainer}>
                <Image src={graficoBarraBase64} style={styles.graficoImagem} />
              </View>
            </View>
          ) : null}

          {/* Gráfico radar (se existir) */}
          {graficoRadarBase64 ? (
            <View>
              <Text style={styles.bold}>{radarTitulo}</Text>
              <View style={styles.graficoContainer}>
                <Image src={graficoRadarBase64} style={styles.graficoImagem} />
              </View>
            </View>
          ) : null}

          {/* Lista de participantes que concluíram */}
          <Text style={styles.listaParticipantesTitulo}>
            {hasProfileGroups
              ? `Participantes que concluíram por agrupamento de perfis (${isRawMode ? 'pontos' : '%' }):`
              : 'Participantes que concluíram (com perfil):'}
          </Text>

          <View style={styles.listaParticipantes}>
            {participantesConcluidos.length === 0 ? (
              <Text style={styles.participanteItem}>Nenhum participante encontrado.</Text>
            ) : (
              participantesConcluidos.map((p, i) => {
                const nome = p.nome || 'Participante';
                const telefone = p.telefone ? ` — ${p.telefone}` : '';

                let infoFinal = '';

                if (hasProfileGroups && Array.isArray(p.grupos) && p.grupos.length > 0) {
                  // Ex: "Tríade Profissional: 10.00 pontos | Tríade Saúde: 7.50 pontos" ou "... 33.00%"
                  const gruposStr = p.grupos
                    .map((g) => {
                      const label = g.label || g.id || 'Grupo';
                      const valorNum = Number(g.percent ?? 0);
                      const valorStr = isNaN(valorNum) ? '0.00' : valorNum.toFixed(2);
                      const unidade = isRawMode ? ' pontos' : '%';
                      return `${label}: ${valorStr}${unidade}`;
                    })
                    .join(' | ');
                  if (gruposStr) infoFinal = ` — ${gruposStr}`;
                } else if (p.perfil) {
                  infoFinal = ` — ${p.perfil}`;
                }

                const linha = `${nome}${telefone}${infoFinal}`;
                const color = p.perfil ? getCor(p.perfil) : '#333';

                return (
                  <Text key={i} style={[styles.participanteItem, { color }]}>
                    {linha}
                  </Text>
                );
              })
            )}
          </View>

          {/* Lista de participantes pendentes */}
          <Text style={styles.listaParticipantesTitulo}>
            Participantes pendentes:
          </Text>

          <View style={styles.listaParticipantes}>
            {participantesPendentes.length === 0 ? (
              <Text style={styles.participanteItem}>Nenhum participante pendente.</Text>
            ) : (
              participantesPendentes.map((p, i) => {
                const nome = p.nome || 'Participante';
                const telefone = p.telefone ? ` — ${p.telefone}` : '';
                return (
                  <Text key={`pendente-${i}`} style={styles.participanteItem}>
                    {`${nome}${telefone}`}
                  </Text>
                );
              })
            )}
          </View>
        </View>
      </Page>
    </Document>
  );
}
